/*
 * Created Date: 16-01-2024, 9:41:04 am
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

const basePath = 'subcription'
export const ROUTER_SUBCRIPTION = {
	plan: `/${basePath}/plan`,
	pricing: `/${basePath}/pricing`
}
